
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Hadapsartomumbaicabs() {



    const cardData =
    {
        keyword: '  Hadapsar to Mumbai Cabs',
        heading: 'Skyline Cabs: Hadapsar to Mumbai Cabs',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Hadapsar to Mumbai Cabs. Whether you are traveling for a business trip, leisure, or an airport transfer, our fleet of well-maintained vehicles and skilled drivers ensure a smooth, timely, and safe ride. With affordable fares, excellent customer service, and a commitment to punctuality, Skyline Cabs makes your journey from Hadapsar to Mumbai effortless and enjoyable. Book your Hadapsar to Mumbai cab today and experience a stress-free ride with Skyline Cabs.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Magarpatta to Mumbai Cab",
      "description": "Skyline Cabs offers efficient and comfortable taxi services from Magarpatta to Mumbai. Whether you're heading to business meetings or leisure, we ensure a safe and timely journey with various vehicle options, including Innova and Ertiga."
    },
    {
      "name": "Hadapsar to Mumbai Taxi Fare",
      "description": "Skyline Cabs provides affordable and transparent fare pricing for trips from Hadapsar to Mumbai. Choose from our fleet of vehicles, such as Innova and Ertiga, and enjoy a comfortable ride."
    },
    {
      "name": "Hadapsar to Mumbai Airport Taxi Fare",
      "description": "Skyline Cabs offers competitive taxi fares from Hadapsar to Mumbai Airport. With professional drivers and well-maintained vehicles, we guarantee a hassle-free journey to Chhatrapati Shivaji International Airport."
    },
    {
      "name": "Hadapsar to Mumbai International Airport Cab",
      "description": "Travel comfortably and on time with Skyline Cabs. We provide reliable taxi services from Hadapsar to Mumbai International Airport. Choose from various vehicles like Innova or Ertiga for a smooth, relaxing ride."
    },
    {
      "name": "Hadapsar to Mumbai Innova Cab",
      "description": "For a comfortable and premium ride from Hadapsar to Mumbai, book an Innova with Skyline Cabs. Ideal for families and small groups, the Innova ensures a spacious and smooth journey."
    },
    {
      "name": "Hadapsar to Mumbai Ertiga Cab",
      "description": "Choose Skyline Cabs for an affordable yet comfortable ride from Hadapsar to Mumbai with an Ertiga. Perfect for small families or groups, the Ertiga provides a spacious, smooth ride at competitive prices."
    },
    {
      "name": "Cab Service in Hadapsar",
      "description": "Skyline Cabs offers prompt and reliable cab services in Hadapsar, Pune. Whether you need a local ride or an outstation trip, we provide well-maintained vehicles and professional drivers to ensure a comfortable journey."
    },
    {
      "name": "Taxi Service in Hadapsar",
      "description": "Skyline Cabs offers excellent taxi services in Hadapsar, Pune. Our fleet of vehicles, including sedans, SUVs, and luxury cars, are available for local, airport, and outstation rides."
    },
    {
      "name": "Hadapsar to Mumbai One Way Taxi",
      "description": "For a one-way trip from Hadapsar to Mumbai, Skyline Cabs offers reliable, affordable taxi services. Choose from various vehicles, including the Innova or Ertiga, and enjoy a comfortable journey."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers seamless and timely airport transfers from Pune to Mumbai Airport. Choose from a variety of vehicles like the Innova and Ertiga, ensuring a smooth and efficient ride."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "For a comfortable yet affordable ride from Pune to Mumbai, Skyline Cabs offers the Ertiga, ideal for families and small groups. Travel in comfort with a spacious and well-maintained vehicle."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Skyline Cabs offers premium Innova cabs for a comfortable ride from Pune to Mumbai. With ample space and a smooth ride, the Innova is perfect for groups and families traveling together."
    },
    {
      "name": "Hadapsar to Mumbai Cab Price",
      "description": "Skyline Cabs provides affordable pricing for trips from Hadapsar to Mumbai. We offer transparent pricing with no hidden costs, ensuring a comfortable ride at competitive rates."
    },
    {
      "name": "Hadapsar to Mumbai Airport Cab",
      "description": "Choose Skyline Cabs for a smooth and comfortable ride from Hadapsar to Mumbai Airport. Our professional drivers ensure you reach the airport on time, with a variety of vehicle options to suit your needs."
    },
    {
      "name": "Hadapsar to Dadar Cabs",
      "description": "Skyline Cabs offers convenient and reliable taxi services from Hadapsar to Dadar. Whether you're visiting for business or leisure, our vehicles, including Innova and Ertiga, guarantee a smooth ride."
    },
    {
      "name": "Dadar to Mumbai Airport Taxi Fare",
      "description": "Skyline Cabs provides affordable and transparent taxi fare pricing from Dadar to Mumbai Airport. Travel comfortably in a range of vehicles, from standard sedans to luxury cars."
    },
    {
      "name": "Hadapsar to Bandra Cabs",
      "description": "For a comfortable ride from Hadapsar to Bandra, Skyline Cabs offers reliable services with a variety of vehicle options. Whether you need an Innova or Ertiga, we ensure a smooth and timely journey."
    },
    {
      "name": "Innova Crysta on Rent in Hadapsar",
      "description": "Skyline Cabs offers the Innova Crysta for rent in Hadapsar, Pune. Ideal for group travel or family trips, this luxurious vehicle ensures comfort and space for a pleasant journey."
    },
    {
      "name": "Hadapsar to Navi Mumbai Cab Fare",
      "description": "Skyline Cabs offers affordable taxi services from Hadapsar to Navi Mumbai, with transparent fare pricing. Choose from a range of vehicles to suit your travel needs."
    },
    {
      "name": "Skyline Cabs",
      "description": "Skyline Cabs provides top-rated cab services for all your travel needs in and around Pune and Mumbai. Whether you're looking for a local ride, airport transfer, or long-distance travel, we ensure safe, reliable, and comfortable journeys."
    },
    {
      "name": "Cab Service in Hadapsar Pune",
      "description": "Skyline Cabs offers reliable and prompt cab services in Hadapsar, Pune. Our fleet includes a variety of vehicles for local and outstation travel, available at competitive rates."
    },
    {
      "name": "Taxi Service in Magarpatta Pune",
      "description": "Skyline Cabs provides excellent taxi services in Magarpatta Pune, offering reliable, affordable, and safe rides to various destinations including Mumbai, Pune Airport, and more."
    }
  ],
  "tableData": [
    ["Magarpatta to Mumbai Cab", "Hadapsar to Mumbai Taxi Fare"],
    ["Hadapsar to Mumbai Airport Taxi Fare", "Hadapsar to Mumbai International Airport Cab"],
    ["Hadapsar to Mumbai Innova Cab", "Hadapsar to Mumbai Ertiga Cab"],
    ["Cab Service in Hadapsar", "Taxi Service in Hadapsar"],
    ["Hadapsar to Mumbai One Way Taxi", "Pune to Mumbai Airport Cab"],
    ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Innova Cab"],
    ["Hadapsar to Mumbai Cab Price", "Hadapsar to Mumbai Airport Cab"],
    ["Hadapsar to Dadar Cabs", "Dadar to Mumbai Airport Taxi Fare"],
    ["Hadapsar to Bandra Cabs", "Innova Crysta on Rent in Hadapsar"],
    ["Hadapsar to Navi Mumbai Cab Fare", "Skyline Cabs"],
    ["Cab Service in Hadapsar Pune", "Taxi Service in Magarpatta Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Hadapsar to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and timely cab services from Hadapsar to Mumbai, ensuring you can count on us for a smooth, on-time journey. Whether you're traveling for business, leisure, or catching a flight, our punctuality is guaranteed."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel comfortably with Skyline Cabs, offering a wide range of well-maintained vehicles including hatchbacks, sedans, SUVs, and luxury cars. With plush interiors, air-conditioning, and ample space, our cabs make your journey from Hadapsar to Mumbai enjoyable and relaxing."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe Journey",
        "WhyChoosedescription": "Our professional drivers are skilled, courteous, and knowledgeable about the best routes from Hadapsar to Mumbai. They are committed to providing a safe, comfortable, and smooth ride while ensuring you get to your destination without any hassle."
    },
    {
        "WhyChooseheading": "Affordable Pricing with Transparent Fares",
        "WhyChoosedescription": "Skyline Cabs offers competitive pricing for your Hadapsar to Mumbai trip, with no hidden charges or surprises. We provide transparent, upfront fare estimates, allowing you to travel with confidence, knowing exactly what you will pay."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, so you can book your cab from Hadapsar to Mumbai at any time of day or night. Whether it’s an early morning business trip or a late-night return, we are ready to accommodate your travel needs."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Choices",
        "WhyChoosedescription": "No matter how many people you’re traveling with, we have the right vehicle for you. Choose from a variety of cabs such as hatchbacks, sedans, SUVs, and luxury cars, all tailored to your comfort and budget requirements for the trip from Hadapsar to Mumbai."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking a cab from Hadapsar to Mumbai is fast and easy with Skyline Cabs. You can use our website or mobile app to get real-time fare estimates, confirm your booking instantly, and track your cab as it arrives at your location."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel with GPS Tracking",
        "WhyChoosedescription": "Your safety is our priority. All of our cabs are GPS-enabled, and every driver undergoes a thorough background check. With Skyline Cabs, you can rest assured that your journey from Hadapsar to Mumbai will be safe, secure, and comfortable."
    }
]











    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Hadapsar to Mumbai with Skyline Cabs?',
            answer:
                'Booking your cab is quick and easy! You can use our website, the Skyline Cabs mobile app, or call our customer support. Just enter your pickup from Hadapsar and drop off in Mumbai, select your vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Hadapsar to Mumbai travel?',
            answer:
                'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars. You can choose the best vehicle based on your group size, preferences, and travel comfort.',
        },
        {
            id: 3,
            question: 'Is the fare from Hadapsar to Mumbai fixed or based on distance?',
            answer:
                'Skyline Cabs offers fixed pricing for your trip from Hadapsar to Mumbai. The fare includes all tolls, taxes, and any additional charges, which are communicated clearly during the booking process.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round-trip cab from Hadapsar to Mumbai?',
            answer:
                'Yes, you can choose either a one-way or round-trip ride based on your needs. Just select your preferred option while making the booking, and we’ll take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does the journey from Hadapsar to Mumbai take?',
            answer:
                'The journey typically takes between 3 to 3.5 hours, depending on the traffic. Our experienced drivers will ensure that you arrive safely and on time.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced and reliable?',
            answer:
                'Yes, all our drivers are thoroughly vetted and experienced in handling long-distance routes. They are well-trained to ensure a smooth, safe, and timely journey.',
        },
        {
            id: 7,
            question: 'Can I schedule a cab in advance for Hadapsar to Mumbai?',
            answer:
                'Yes, you can schedule your ride in advance using our app or website. We recommend booking ahead, especially for peak hours or weekends, to ensure availability.',
        },
        {
            id: 8,
            question: 'Is airport drop from Hadapsar to Mumbai available?',
            answer:
                'Yes, we offer convenient airport drop-off services from Hadapsar to Mumbai Domestic and International Airports. Just provide your flight details, and we’ll ensure timely drop-off.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Hadapsar to Mumbai booking?',
            answer:
                'Yes, you can easily modify or cancel your booking through our app or website. Our customer service team is also available to assist you if needed.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Hadapsar to Mumbai trip?',
            answer:
                'Skyline Cabs offers a comfortable, reliable, and affordable travel experience. With well-maintained cars, experienced drivers, and transparent pricing, we ensure a hassle-free journey for all your travel needs.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Amit Patil",
            rating: 5,
            review: "I had a great experience traveling from Hadapsar to Mumbai with Skyline Cabs. The car was clean, the driver was punctual and friendly, and the overall ride was very comfortable. I highly recommend this service!"
        },
        {
            name: "Miss. Shalini Rao",
            rating: 4,
            review: "The service was good. The car was in excellent condition, and the driver was professional. I think the ride could be improved by adding in-car Wi-Fi for long trips, but overall, I’m happy with the experience."
        },
    ];
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hadapsar to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/hadapsar-to-mumbai-cab.jpg",
  "description": "Book Hadapsar to Mumbai cab service with Skyline Cabs for a reliable, on-time, and affordable ride. AC sedans, SUVs, and experienced drivers available 24/7 for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7845"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/hadapsar-to-mumbai-cab-service"
  }
};


      
    


    return (
        <div>


<Helmet>
  <title>Hadapsar to Mumbai Cab Service | AC Taxi at Affordable Fare | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Hadapsar to Mumbai cab service with Skyline Cabs for a reliable, on-time, and affordable ride. AC sedans, SUVs, and experienced drivers available 24/7 for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Hadapsar to Mumbai Cab Service, Cab from Hadapsar to Mumbai, One-Way Taxi Hadapsar to Mumbai, Round Trip Cab Hadapsar Mumbai, AC Cab Hadapsar to Mumbai, SUV Taxi Hadapsar to Mumbai, Online Cab Booking Hadapsar Mumbai, Affordable Cab Service Hadapsar to Mumbai, Skyline Cabs Hadapsar Mumbai, 24/7 Taxi Hadapsar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/13.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hadapsartomumbaicabs;